export const LoadMorePosts = {
  init: function () {
    this.cacheSelectors();
    this.bindEvents();
    this.updateSettings();
  },

  cacheSelectors: function () {
    this.posts = document.querySelectorAll('.cards');
    this.loadMoreButton = document.querySelectorAll('.load-more') ? document.querySelectorAll('.load-more') : null;
    this.isMobile = () => window.matchMedia('(max-width: 767px)').matches;
    this.initialVisiblePosts = 4;
    this.additionalPosts = 3;
    this.updateSettings();
  },  

  bindEvents: function () {
    if (!this.loadMoreButton) {
      return;
    }

    this.loadMoreButton.forEach(element => {
      element.addEventListener("click", () => { this.updatePostVisibility() } );
    });

    window.addEventListener('resize', this.updateSettings.bind(this));
  },
  updateSettings: function () {
    this.initialVisiblePosts = this.isMobile() ? 4 : 4; 
    this.additionalPosts = this.isMobile() ? 2 : 3;
  },
  updatePostVisibility: function () {
    console.log("teste");
    let blockActive = document.querySelector(".resultado__grid.active");
    let items = blockActive.querySelectorAll(".resultado__card.flex--none") ? blockActive.querySelectorAll(".resultado__card.flex--none") : null ;

    if(items){
      if(items.length <= this.additionalPosts ){
        items.forEach((el) => {
          el.classList.remove("flex--none");
        });
        blockActive.querySelector(".resultado__button").style.display = "none";
        return;
      }
      
      items.forEach((el, index) => {
        if((index + 1) > this.additionalPosts) { return; } 
        el.classList.remove("flex--none");
      });

    }
  }
};

  LoadMorePosts.init();

